
const firstHeader =['车型','科目','科目名称','期初数','合计',]

const saleHeader = [
    '运费支付','关税支付','其他费用','调整项','费用总计','调整说明',
    
]
const carTypeItem = [ '运费支付','关税支付','其他费用','费用合计',]

export { saleHeader,carTypeItem,firstHeader, }